import { createServerFn } from "@tanstack/react-start";
import { supabaseAdmin } from "@/integrations/supabase/client.server";
import { DISCONTINUED_PS_IDS_PG_LIST } from "@/lib/discontinued-products";

// Υπολογίζεται μία φορά την ημέρα (cache 24 ωρών) — όχι σε κάθε επίσκεψη.
const DAY_MS = 24 * 60 * 60 * 1000;
let cached: { count: number; at: number } | null = null;

export const getAvailableProductCount = createServerFn({ method: "GET" }).handler(async () => {
  if (cached && Date.now() - cached.at < DAY_MS) return { count: cached.count };
  const { count, error } = await supabaseAdmin
    .from("products")
    .select("id", { count: "exact", head: true })
    .eq("active", true)
    .gt("stock_quantity", 0)
    .not("ps_id", "in", DISCONTINUED_PS_IDS_PG_LIST);
  if (error || count == null) return { count: cached?.count ?? null };
  cached = { count, at: Date.now() };
  return { count };
});
